import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Stack,
  Typography,
} from "@mui/material";

export default function Info({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>About Project Sekai Stickers</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <Typography variant="body1">
            Create your own custom Project Sekai stickers with editable text,
            instant canvas preview, and one-tap export. 这是一个轻量但很实用的贴纸编辑器，
            适合快速做聊天用图。
          </Typography>

          <Typography variant="body2" color="text.secondary">
            Credits
          </Typography>
          <Typography variant="body2">
            Original stickers from{" "}
            <Link
              href="https://www.reddit.com/r/ProjectSekai/comments/x1h4v1/after_an_ungodly_amount_of_time_i_finally_made/"
              target="_blank"
              rel="noreferrer"
            >
              Reddit
            </Link>
            , cropped images by{" "}
            <Link
              href="https://github.com/Modder4869"
              target="_blank"
              rel="noreferrer"
            >
              Modder4869
            </Link>
            , maintained by KurisuRakko
            .
          </Typography>

          <Typography variant="body2" color="text.secondary">
            Notes
          </Typography>
          <Typography variant="body2">
            This UI refresh keeps the original sticker-making logic intact while
            making the editor easier to browse on both desktop and mobile.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
